<template>
<el-dialog modal-append-to-body append-to-body :visible="!!detail" title="查看详情" width="1000px" @close="closeDialog">
  <el-form :model="info" :rules="rules" ref="form" label-width="100px">
    <el-form-item label="描述：" prop="description">
      {{info.description}}
    </el-form-item>
    <el-form-item label="更新时间：" prop="updateTime">
      {{info.updateTime | moment}}
    </el-form-item>
    <el-form-item v-if="info.taskStatus === 0" label="导入数据：" prop="miningAirDrops">
      <import-airdrop v-model="miningAirDrops" @change="handleImport" />
    </el-form-item>

    <el-table v-loading="loading" :data="airdrops" border style="width: 100%">
      <el-table-column prop="userId" label="用户ID"/>
      <el-table-column prop="coinType" label="币种"/>
      <el-table-column prop="coinAmount" label="空投数量"></el-table-column>
      <el-table-column prop="redeemCode" label="空投卡券"></el-table-column>
      <!-- <el-table-column prop="coinAmount" label="可用数量"/>
      <el-table-column prop="coinFroze" label="冻结数量"/>
      <el-table-column prop="redeemCode" label="兑换码"/> -->
    </el-table>
    <pagination :size="airdropPagination.size" :page="airdropPagination.page" :total="airdropTotalCount" @pageChanged="handleCurrentChange">
    </pagination>
  </el-form>
  <span slot="footer" class="dialog-footer">
    <el-button @click="subQuery()">转账中/转账失败记录</el-button>
    <el-button @click="resetError()">重置失败至未转账</el-button>
    <el-button @click="closeDialog">取消</el-button>
    <div>
      <el-table :data="unTransInfo">
         <el-table-column prop="userId" label="用户ID"></el-table-column>
         <el-table-column prop="coinType" label="币种"></el-table-column>
         <el-table-column prop="coinAmount" label="可用数量"></el-table-column>
         <el-table-column prop="coinFroze" label="冻结数量"></el-table-column>
         <el-table-column prop="dropStatus" label="状态">
           <template slot-scope="scope">{{parseStatusTran(scope.row.dropStatus)}}</template>
         </el-table-column>
         <el-table-column prop="errorMsg" label="转账失败信息"></el-table-column>
      </el-table>
    </div>
    </span>
</el-dialog>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex';
import importAirdrop from '../import';
import Pagination from 'components/pagination';
import api from '../../api';

export default {
  name: 'airdropDetail',
  data() {
    return {
      info: {},
      miningAirDrops: [],
      loading: false,
      rules: {
        importAirDrop: {
          type: 'array',
          required: true,
          message: '请填写',
          trigger: 'change'
        }
      }
    };
  },
  computed: {
    ...mapState('airdrop', [
      'detail',
      'airdropPagination',
      'airdropTotalCount',
      'airdrops',
      'unTransInfo'
    ])
  },
  components: {
    importAirdrop,
    Pagination
  },
  watch: {
    detail(val) {
      if (val) {
        this.info = (val && Object.assign({}, val)) || {};
        this.getAirDropList({
          taskId: val.id,
          page: 1
        });
      } else {
        this.info = {};
      }
    }
  },
  methods: {
    ...mapMutations('airdrop', ['setDetail','setUnTransInfo']),
    ...mapActions('airdrop', ['importAirDrop', 'reqAirDrops','reqUnTransfer']),
    closeDialog() {
      this.setDetail(null);
      this.setUnTransInfo(null);
      this.$refs['form'].resetFields();
    },
    handleCurrentChange(pagination) {
      this.getAirDropList(pagination);
    },
    getAirDropList(data = {}) {
      this.loading = true;
      this.reqAirDrops({
        taskId: this.info.id,
        ...this.airdropPagination,
        ...data
      }).then(() => {
        this.loading = false;
      });
    },
    handleImport() {
      const that = this;
      this.$refs['form'].validate(valid => {
        if (valid) {
          this.importAirDrop({
            taskId: this.info.id,
            miningAirDrops: JSON.stringify(this.miningAirDrops)
          }).then(() => {
            this.$message({
              message: '修改成功！',
              type: 'success'
            });
            this.getAirDropList({
              page: 1
            });
          });
        }
      });
    },

    subQuery(){
      this.reqUnTransfer({ taskId: this.info.id,status: this.info.taskStatus});
    },

    resetError(){
      api.resetError({ taskId: this.info.id,status: this.info.taskStatus});
    },

    parseStatusTran(status){
        if (status === 0) {
          return '未转账';
        }
        if (status === 1) {
          return '转账中';
        }
        if (status === 3) {
          return '转账失败';
        }
    }

  },
  mounted() {
    if (this.info && this.info.id) {
      getAirDropList({
        page: 1
      });
    }
  }
};
</script>
